export const locale = {
  lang: 'id',
  data: {
    'EVENTCONFIRM': 'Konfirmasi',
    'EVENTYES': 'Ya',
    'EVENTCANCEL': 'Batal'
  }
};
